/**
 * Display labels for the numeric codes the gateway returns for rides and vehicles.
 * Index (or key) = wire value.
 */

/** Vehicle status codes. Rebalance/Maintain/Out of service are set by field-ops flows, not by hand. */
export const VEHICLE_STATUSES: Record<number, { label: string; color: string; manual: boolean }> = {
  0: { label: 'Normal', color: 'green', manual: true },
  1: { label: 'Error', color: 'red', manual: true },
  3: { label: 'Deactivated', color: 'default', manual: true },
  5: { label: 'Rebalance', color: 'blue', manual: false },
  6: { label: 'Maintain', color: 'orange', manual: false },
  7: { label: 'Out of service', color: 'volcano', manual: false },
  9: { label: 'Hold', color: 'purple', manual: true },
};

/** Status codes that require (1) or allow (9) a status note. */
export const NOTE_REQUIRED_STATUS = 1;
export const NOTE_ALLOWED_STATUSES = [1, 9];

export const PROVIDERS = ['Omni', 'Meig'] as const;

/** Ride.state. */
export const RIDE_STATES: Record<number, { label: string; color: string }> = {
  0: { label: 'Unconfirmed', color: 'gold' },
  1: { label: 'Success', color: 'green' },
  2: { label: 'Error', color: 'red' },
};

export const LOCK_METHODS = [
  'GPRS',
  'Bluetooth',
  'Admin',
  'Communication failure',
  'Timeout',
  'Out of balance',
  'Reached maximum',
  'Service off',
  'Customer end (vehicle idle)',
  'Auto-ended (vehicle idle)',
  'Start-end in NRZ',
  'GPRS + malfunction',
  'Pause auto-end',
] as const;

export const UNLOCK_METHODS = ['GPRS', 'Bluetooth', 'Admin'] as const;


/** Label for an index-coded value, falling back to the raw code. */
export function labelOf(list: readonly string[], code: number | null | undefined): string {
  if (code === null || code === undefined) return '—';
  return list[code] ?? `#${code}`;
}


/** Phone with country code, last four digits only (never show full numbers in lists). */
export function phoneLabel(phone: number | null | undefined, countryCode: number | null | undefined, mask: (p: number) => string): string {
  if (phone === null || phone === undefined) return '—';
  return `+${countryCode ?? 1} ${mask(phone)}`;
}
